var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKnowledgeBaseNode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "currentColor",
    stroke: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "book"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M1.75 11.0842C2.5481 10.6234 3.45343 10.3809 4.375 10.3809C5.29657 10.3809 6.2019 10.6234 7 11.0842C7.7981 10.6234 8.70343 10.3809 9.625 10.3809C10.5466 10.3809 11.4519 10.6234 12.25 11.0842",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M1.75 3.50024C2.5481 3.03946 3.45343 2.79687 4.375 2.79688C5.29657 2.79688 6.2019 3.03946 7 3.50024C7.7981 3.03946 8.70343 2.79687 9.625 2.79688C10.5466 2.79688 11.4519 3.03946 12.25 3.50024",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M3.9375 5.6875C4.07052 5.6875 4.22141 5.6875 4.375 5.6875C4.52859 5.6875 4.67948 5.6875 4.8125 5.6875",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M9.1875 5.6875C9.32052 5.6875 9.47141 5.6875 9.625 5.6875C9.77859 5.6875 9.92948 5.6875 10.0625 5.6875",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M3.9375 7.4375C4.07052 7.4375 4.22141 7.4375 4.375 7.4375C4.52859 7.4375 4.67948 7.4375 4.8125 7.4375",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M9.1875 7.4375C9.32052 7.4375 9.47141 7.4375 9.625 7.4375C9.77859 7.4375 9.92948 7.4375 10.0625 7.4375",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M1.75 3.5V11.0833",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M7 3.5V11.0833",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M12.25 3.5V11.0833",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKnowledgeBaseNode);
export default __webpack_public_path__ + "static/media/knowledgeBaseNode.b296460e75cdb913ae78716d075d23b3.svg";
export { ForwardRef as ReactComponent };